import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Select from 'react-select';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import { alterouPagina } from '../../util/filtros';
import ItinerarioEncomenda from './ItinerarioEncomenda'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoItinerario from '../itinerario/BotoesPaginacaoItinerario';
import PaginacaoItinerario from '../itinerario/PaginacaoItinerario';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import selecionarRota from '../../actions/rota/selecionarRota';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { inativarVendaSite } from '../../actions/itinerario/ativarOuInativarVendaSite'
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';

export const CabecalhoTabela = ({ habilitadoSite }) => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Data/Hora saída</div>
            <div className="col">Assentos</div>
            <div className="col">Veículo</div>
            <div className="col ml-md-2">Rota</div>
            <div className="col">Prestador</div>
            {habilitadoSite ?
                <div className="col ml-md-n4">Venda Site<br />Ativo/Inativo</div> : ''
            }
            <div className="col">Categorias</div>
            <div className="col">Itinerário<br />ativo/inativo</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);

export class ItinerariosEncomenda extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            rotaSelecionada: null,
            dataPartidaSelecionada: null,
            motoristasSelecionados: [],
            trechosSelecionados: [],
            cidadesSelecionadas: [],
            trechosBloqueioDescontoSelecionados: [],
            codigoItinerarioChecked: null,
            exibeTipoCategoriaUnica: true
        };
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id);
            }
            this.props.selecionarRota([]);
        }
        if (alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerarios();
        }
    }

    limparSelecionarItinerario() {
        this.props.selecionarItinerario(null);
    }

    limparCampos() {
        this.props.reset('formularioCadastroItinerario');
        this.limparMotoristasSelecionados();
        this.limparTrechosSelecionados();
        this.limparCidadesSelecionadas();
        this.handleCheckedTipoCategoriaUnica(true);
        this.props.limparVeiculoItinerarioSelecionado();
        this.props.selecionarItinerario(null);
        this.props.limparItinerarios()
    }

    exibirTabelaItinerariosEdicao() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (<div className="col-12 conteudo-internas">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoItinerario}
                                           BotoesPaginacao={BotoesPaginacaoItinerario}
                                           itinerarios={this.props.itinerarios}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                        <div className="lista-table">
                            {this.exibirItinerarios()}
                        </div>
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return <div>Nenhum itinerário disponível.</div>;
    }

    exibirTabelaItinerarios() {
        if (this.props.itinerarios && this.props.itinerarios.length) {
            return (<div className="col-12 conteudo-internas">
                    <CabecalhoTabela habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                    <div className="lista-table">
                        {this.exibirItinerarios()}
                    </div>
                </div>
            )
        }
        return <div>Nenhum itinerário disponível.</div>;
    }

    exibirItinerarios() {
        if (this.props.itinerarios) {
            return this.props.itinerarios
                .map((itinerario, index) => <ItinerarioEncomenda key={index}
                    isEdicao={this.props.isEdicao}
                    buscarItinerarios={this.props.buscarItinerarios}
                    itinerario={itinerario}
                    indice={index}
                />)
        }
    }

    selecionarData(data) {
        this.setState({ dataPartidaSelecionada: data });
        this.props.buscarItinerarios();
    }

    selecionarRota(rota) {
        this.setState({
            dataPartidaSelecionada: null
        });
        this.props.selecionarRota(rota);
        this.setState({ trechos: this.props.rotas.filter(it => it.id === rota.value)[0].trechosDto });
        this.props.buscarItinerarios();
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: `${elemento.prefixo ? elemento.prefixo : 'Prefixo não informado'}: ${elemento.cidadeOrigem.nome}-${elemento.cidadeOrigem.uf} -> ${elemento.cidadeDestino.nome}-${elemento.cidadeDestino.uf} / ${elemento.prestador ? elemento.prestador : 'Prestador não informado'}`,
                                value: elemento.id
                            }))}
                        onChange={value => this.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                        && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    render() {
        return (
            <div>
                {this.props.isEdicao ? this.exibirTabelaItinerariosEdicao() : this.exibirTabelaItinerarios()}
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        itinerarios: state.itinerarios.itinerarios,
        veiculos: state.veiculos.veiculos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,

    });


export default connect(mapStateToProps,
    {
        excluirItinerarios,
        buscarRotas,
        buscarVeiculos,
        determinaPaginaAtual,
        selecionarRota,
        limparItinerarios,
        buscarTiposPreco,
        selecionarItinerario,
        inativarItinerario,
        inativarVendaSite,
        limparVeiculoItinerarioSelecionado
    })(reduxForm({
        form: 'formularioCadastroItinerario'
    })(ItinerariosEncomenda))
